import { useTranslation } from 'react-i18next'

import { EMPTY_LIST } from '../../../../constants/common'
import { useDateLocale, useTimeZone } from '../../../../hooks'
import Text from '../../../Text'
import { getCalendarGridItemsByDay } from '../../CalendarGrid.utils'

import { useCalendarGridWeekAllDaySelection } from './CalendarGridWeekAllDay.hooks'
import {
  getCalendarGridDaySpanTrackCount,
  getCalendarGridWeekSpans,
} from './CalendarGridWeekAllDay.utils'
import { CalendarGridWeekAllDayCell } from './CalendarGridWeekAllDayCell'
import { CalendarGridWeekAllDaySpan } from './CalendarGridWeekAllDaySpan'

import * as styles from './CalendarGridWeekAllDay.module.css'

function CalendarGridWeekAllDay({
  canMoveItems,
  dayLoads,
  days,
  items,
  today,
  onClickItem,
  onClickSecondaryLabel,
  onSelectDays,
}) {
  const { t } = useTranslation()

  const locale = useDateLocale()
  const timezone = useTimeZone()

  const {
    getIsDaySelected,
    handlePointerDownDay,
    handlePointerEnterDay,
    isSelecting,
  } = useCalendarGridWeekAllDaySelection({ days, onSelectDays })

  const itemsByDay = getCalendarGridItemsByDay({ items, locale, timezone })

  const spans = getCalendarGridWeekSpans({ days, items })

  return (
    <>
      <Text isSecondary className={styles.corner}>
        {t('Calendar.AllDayKey')}
      </Text>
      <div className={styles.lane}>
        {days.map((day, dayIndex) => (
          <CalendarGridWeekAllDayCell
            canMoveItems={canMoveItems}
            day={day}
            dayIndex={dayIndex}
            dayLoad={dayLoads[day.date]}
            days={days}
            isSelected={getIsDaySelected(dayIndex)}
            items={itemsByDay[day.date] ?? EMPTY_LIST}
            key={day.date}
            spanCount={getCalendarGridDaySpanTrackCount({ dayIndex, spans })}
            today={today}
            onClickItem={onClickItem}
            onClickSecondaryLabel={onClickSecondaryLabel}
            onPointerDown={onSelectDays ? handlePointerDownDay : undefined}
            onPointerEnter={isSelecting ? handlePointerEnterDay : undefined}
          />
        ))}
        {spans.map(span => (
          <CalendarGridWeekAllDaySpan
            endIndex={span.endIndex}
            item={span.item}
            key={span.item?.id}
            startIndex={span.startIndex}
            track={span.track}
            onClickItem={onClickItem}
          />
        ))}
      </div>
    </>
  )
}

export default CalendarGridWeekAllDay
